import { constantLive, LiveValue, type HttpClient, type Live } from '@/model';
import { capabilities } from './protocol';

const clients = new WeakMap<HttpClient, CapabilityAdmission>();
const unavailable = constantLive<readonly string[]>([]);
/** Admission is separate from numeric protocol and declaration. Socket ready owns a live connection. */
export class CapabilityAdmission {
  readonly state = new LiveValue<readonly string[]>([]);
  private epoch = 0;
  private socket = false;
  capture(): number { return this.epoch; }
  reset(): void { this.epoch++; this.socket = false; this.publish([]); }
  beginConnection(): number { this.reset(); return this.epoch; }
  ready(names: unknown, epoch: number): void { if (epoch !== this.epoch) return; this.socket = true; this.publish(names); }
  http(names: unknown, epoch: number): void { if (epoch === this.epoch && !this.socket) this.publish(typeof names === 'string' ? names.split(',') : []); }
  private publish(names: unknown): void {
    const value = Array.isArray(names) ? [...new Set(names.filter((name): name is string => typeof name === 'string' && capabilities.includes(name.trim())).map(name => name.trim()))].sort() : [];
    if (JSON.stringify(value) !== JSON.stringify(this.state.get())) this.state.set(value);
  }
}
export function bindAdmission(http: HttpClient, admission: CapabilityAdmission): void { clients.set(http, admission); }
export function admissionFor(http: HttpClient): CapabilityAdmission | undefined { return clients.get(http); }
export function acknowledgedCapabilities(http: HttpClient): Live<readonly string[]> { return clients.get(http)?.state ?? unavailable; }
